import React from "react";
import { Box, Typography } from "@mui/material";

const TILE_BACKGROUNDS = [
  "linear-gradient(135deg, #2d2926 0%, #9a826b 48%, #24211f 100%)",
  "linear-gradient(145deg, #171717 0%, #73665c 55%, #d2b99b 100%)",
  "linear-gradient(125deg, #8f7966 0%, #252525 52%, #b9a18a 100%)",
  "linear-gradient(145deg, #24211f 0%, #b8a084 52%, #403932 100%)",
  "linear-gradient(135deg, #7d6753 0%, #1b1b1b 55%, #c9ad8d 100%)",
  "linear-gradient(150deg, #1f1f1f 0%, #685b50 50%, #a78f75 100%)",
];

export default function StrictSurprisePreview({
  mode = "surprise",
}) {
  const isManualHidden = mode === "host-hidden";

  const title = isManualHidden
    ? "Gallery hidden by host"
    : "Unlocks at midnight";

  const description = isManualHidden
    ? "Everyone’s photos and Boomerangs will appear when the host reveals the gallery."
    : "Everyone’s photos and Boomerangs will appear here.";

  return (
    <Box
      sx={{
        width: "min(720px, 95vw)",
        maxWidth: "100%",
        mx: "auto",
        mt: 3,
        mb: 10,
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          mb: 1.25,
          color: "#111",
          fontSize: {
            xs: 20,
            sm: 22,
          },
          fontWeight: 700,
          lineHeight: 1.2,
        }}
      >
        Everyone’s POV
      </Typography>

      <Box
        role="img"
        aria-label={
          isManualHidden
            ? "Gallery hidden by host"
            : "Gallery unlocks at midnight"
        }
        sx={{
          position: "relative",
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: "3px",
          overflow: "hidden",
          borderRadius: 1.5,
          backgroundColor: "#fff",
          isolation: "isolate",
        }}
      >
        {TILE_BACKGROUNDS.map((background, index) => (
          <Box
            key={index}
            aria-hidden="true"
            sx={{
              aspectRatio: "1 / 1",
              overflow: "hidden",
              background,
              filter: "blur(7px)",
              transform: "scale(1.08)",
              opacity: 0.82,
            }}
          />
        ))}

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            px: 2,
            color: "#fff",
            backgroundColor: "rgba(0,0,0,0.3)",
            textShadow: "0 2px 12px rgba(0,0,0,0.65)",
            pointerEvents: "none",
          }}
        >
          <Box
            component="svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            sx={{
              width: 31,
              height: 31,
              mb: 0.75,
              fill: "none",
              stroke: "currentColor",
              strokeWidth: 1.8,
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }}
          >
            <rect
              x="5"
              y="10"
              width="14"
              height="11"
              rx="2"
            />

            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
          </Box>

          <Typography
            sx={{
              color: "inherit",
              fontSize: {
                xs: 17,
                sm: 19,
              },
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              mt: 0.6,
              maxWidth: 430,
              color: "rgba(255,255,255,0.9)",
              fontSize: {
                xs: 12.5,
                sm: 14,
              },
              lineHeight: 1.35,
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}